// Versions identify comparable metric populations, not optional chart fields.
export const CURRENT_DASHBOARD_SNAPSHOT_VERSION = 2;
export const LEGACY_DASHBOARD_SNAPSHOT_VERSION = 1;
export const DASHBOARD_SNAPSHOT_VERSION_CUTOFF = '2026-10-20';

export function dashboardSnapshotDate(generatedAt) {
  const time = Date.parse(generatedAt);
  return Number.isFinite(time) ? new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(new Date(time)) : null;
}

export function validSnapshotDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const time = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === value;
}
